import { cookies } from './cookies'
import { hash } from './hash'

(window as any).announce = function announce({
    selector = ``,
    closeSelector = `[data-close]`,
} = {}) {
    document.querySelectorAll<HTMLElement>(selector).forEach(node => {
        const closeNode = node.querySelector(closeSelector) as HTMLElement;
        if (!closeNode) return;
        const content = node.innerText.trim();
        const contentHash = hash(content);
        const hasContent = content.length !== 0;
        const { cookie, start, end } = node.dataset;
        const isClosed = cookies[`announce${contentHash}`];
        const now = new Date();
        const started = !start || now >= new Date(start);
        const ended = end && now >= new Date(end);
        const visible = hasContent && started && !ended && !isClosed;
        toggle(node, visible);

        closeNode.onclick = function () {
            document.cookie = `announce${contentHash}=1;${cookie}`;
            toggle(node, false);
        }
    });
}

function toggle(node: HTMLElement, visible: boolean) {
    node.style.display = visible ? `block` : `none`;
}